import { render, staticRenderFns } from "./Contributors.vue?vue&type=template&id=7d7b395c&scoped=true&"
import script from "./Contributors.vue?vue&type=script&lang=js&"
export * from "./Contributors.vue?vue&type=script&lang=js&"
import style0 from "./Contributors.vue?vue&type=style&index=0&id=7d7b395c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7b395c",
  null
  
)

export default component.exports